import React, { Component } from 'react';
import { connect } from 'react-redux';
import BaseItem from './components/carousel/index';
import Top from './components/top';
import { productSelect, publicLoginForCpm } from './api';
import ProductCart from '../../components/CpProductCard/CpProductCard';
import { RightOutlined } from '@ant-design/icons';
import { addProduct, reduceProduct } from '../../store/actions/shopCartActions';
import { planListAddProduct } from '../../store/actions/planListActions';
import { queryString } from '../../util/qs';
import SearchTop from './components/search';
import CustomModal from './components/customModal';
import { STATIC_RESOURCE } from '../../origin';
import Bottom from './components/bottom';
import { getAllParams } from '../../util/tool';
import './base.less';

const copyright_config = {
  zh_title: 'Copyright ©2023 正大电子商务（浙江）有限公司 版权所有 浙ICP备19006554号-1',
  en_title: 'Copyright ©2023 CP E-commerce (Zhejiang) Co., Ltd. Zhejiang ICP No.19006554-1'
};

const base_direct_mining = {
  zh_title: '商品推荐',
  en_title: 'Recommend Products'
};
const goods_resource = {
  zh_title: '商品资源',
  en_title: 'Goods Resource'
};
const more_config = {
  zh_title: '更多',
  en_title: 'More'
};

const queryParams = getAllParams();

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList: [],
      language: 'zh_',
    };
  }
  componentDidMount() {
    if (queryParams.token) {
      this.authenticationInformation();
    } else {
      this.getProductList();
    }
    // const language = localStorage.getItem('language') || 'zh_';
    // this.setState({ language });
  }

  static getDerivedStateFromProps(props) {
    const { localeLanguage: { language } } = props;
    return { language };
  }

  authenticationInformation = async () => {
    try {
      const params = ['format', 'requestid', 'sign_method', 'timestamp', 'v', 'sign', 'appid'].reduce((acc, cur) => ({ ...acc, [cur]: queryParams[cur] }), {});
      const { data: { data, code } } = await publicLoginForCpm({ cpm_token: queryParams.token?.replace(/\s/g, '+')?.replace(/\s+/g, '')?.trim() || '' }, params);

      if (+code === 0) {
        const { token, user_info: { company_id, username, account, id }, company_info: { company_name, warehouse_type, group_type } } = data;
        localStorage.setItem('token', token);
        localStorage.setItem('userName', `${company_name ? company_name : ''}(${username})`);
        localStorage.setItem('account', account);
        localStorage.setItem('companyId', company_id);
        localStorage.setItem('companyName', company_name);
        localStorage.setItem('warehouse_type', warehouse_type);
        localStorage.setItem('user_id', id);
        localStorage.setItem('group_type', group_type);
        localStorage.removeItem('select_rows_cache');
        window.location.href = '/basic/index';
      }
    } catch (error) {
      console.log(error);
      window.localStorage.clear();
      window.location.href = '/login';
    }
  }
  getProductList = async () => {
    const params = { "name": "", "type": "1", "sys_cat_id": "", "sys_cat_pid": "", "page": 1, "page_size": 10 };
    const { data: { data: { list = [] }, code } } = await productSelect(params);
    if (+code === 0) {
      const productList = list.map(product => ({
        ...product, id: product.sale_id,
        normsId: product.norms_id,
        name: product.sale_name,
        sellerId: product.supplier_name,
        sellerName: product.supplier_name,
        store: product.stock_cur_num,
        imgUrl: product.sale_head_img || product.sku_head_img || product.spu_head_img,
        title: product.sale_name,
        price: product.sale_price,
        subTitle: `供应商：${product.supplier_name}`,
      }));
      this.setState({ productList });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  renderProduct = (productList) => {
    const currencyStringify = JSON.parse(localStorage.getItem('currencyItem') || JSON.stringify({ "id": 3, "currency": "人民币", "currency_symbol": "¥", "currency_en": "RMB", "exchange_rate": "1.0000", "status": 1 }));
    const { language = 'zh_' } = this.state;
    const rowLen = Math.ceil(productList.length / 5);
    const rows = [];
    for (let i = 0; i < rowLen; i++) {
      const temp = { children: [] };
      rows.push(temp);
      for (let j = 0, colLen = 5; j < colLen; j++) {
        productList[i * 5 + j] && temp.children.push(productList[i * 5 + j]);
      }
    }
    return (
      <React.Fragment>
        {rows.map((row, index) => {
          return (
            <div key={index} className="product-row-container">
              {row.children.map((product, subIndex) => {
                return (
                  <ProductCart
                    language={language}
                    {...currencyStringify}
                    key={product.id}
                    end={subIndex === 4}
                    addProduct={(value) => {
                      this.add(value, product);
                    }}
                    planListAddProduct={(value) => {
                      this.planAddProduct(value, product);
                    }}
                    toProductDetail={() => {
                      this.toProductDetail(product);
                    }}
                    reFresh={() => {
                      this.getProductList();
                    }}
                    transferOrder={(id, orderNo) => { this.transferOrder(id, orderNo); }}
                    {...product}
                    stock={product.stock_cur_num + product.unit}
                  />
                );
              })}
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  toProductDetail = (product) => {
    const { spu_id, org_id, norms_id } = product;
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + org_id + '/' + norms_id);
  };
  add = (value, product) => {
    this.props.addProduct(product, value);
  }
  planAddProduct = (value, product) => {
    this.props.planListAddProduct(product, value);
  }
  transferOrder = (id, orderNo) => {
    // console.log('预订转订单');
    this.props.history.push(`/basic/transfer/order?${queryString({ id, orderId: orderNo })}`);
  }
  searchTypeChanged = (value) => {
    this.setState({
      searchType: value
    });
  }

  searchValueChanged = (value) => {
    this.setState({
      searchValue: value
    });
  }
  render() {
    const { productList = [], language = 'zh_' } = this.state;
    return (
      <>
        <SearchTop language={language} />
        <Top language={language} />
        <div className='base-index'>
          {/* <div class="b_list">
            <div class="b_scroll">
              {
                Array.from({ length: 10 }).map((item, index) => {
                  return <div className='b_item' key={index}>{index}</div>;
                })
              }
              {
                Array.from({ length: 10 }).map((item, index) => {
                  return <div className='b_item' key={index}>{index}</div>;
                })
              }
            </div>
          </div> */}
          <div className='location-title'>{base_direct_mining[`${language}title`]}</div>
          <div className='base-item'>
            <BaseItem bg='#F5FFEB' type='1' textBg='rgba(107, 168, 45, 0.70)' language={language} />
            <BaseItem bg='#FFF7E1' type='2' textBg='rgba(255, 157, 0, 0.70)' language={language} />
          </div>
        </div>
        <div className='base-product-container'>
          <div className='base-product-container-top'>
            <span>{goods_resource[`${language}title`]}</span>
            <span onClick={() => this.props.history.push('/basic/home')}>{more_config[`${language}title`]}<RightOutlined /></span>
          </div>
          <div className="product-container">
            {this.renderProduct(productList)}
          </div>
        </div>
        <div className='base-bottom'>
          <div className='base-bottom-left'>
            <div className='base-bottom-left-imgs'>
              <img src={`${STATIC_RESOURCE}/cp_purchase/index/logo2.png`} alt='' />
              <img src={`${STATIC_RESOURCE}/cp_purchase/index/logo3.png`} alt='' />
            </div>
            <div className='base-bottom-left-text'>{copyright_config[`${language}title`]}</div>
          </div>
          <Bottom language={language} />
          {/* <div className='base-bottom-right'>
            <div className='base-bottom-right-contact-title'>{concat_config[`${language}title`]}</div>
            {
              link_config.map((item, index) => {
                return <div className='base-bottom-right-link' key={index}>
                  <span>{item[`${language}title`]}</span>
                  <span>:{item.detail}</span>
                </div>;
              })
            }
          </div> */}
        </div>
        <CustomModal />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const { shopCart, localeLanguage } = state;

  return {
    productsInCart: shopCart.products,
    localeLanguage
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProduct: (product, value) => {
      dispatch(addProduct(product, value));
    },
    planListAddProduct: (product, value) => {
      dispatch(planListAddProduct(product, value));
    },
    reduceProduct: (productId) => {
      dispatch(reduceProduct(productId));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Index);